var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsApadrinharIconFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.43 28",
    style: {
      enableBackground: "new 0 0 22.43 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ADD8E6;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#ADD8E6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.21,28L11.21,28c-0.42,0-0.76-0.34-0.76-0.76v-4.18c0-0.42,0.34-0.76,0.76-0.76h0 c0.42,0,0.76,0.34,0.76,0.76v4.18C11.98,27.66,11.64,28,11.21,28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.35,26.38L14.35,26.38c-0.42,0-0.76-0.34-0.76-0.76v-2.9c0-0.42,0.34-0.76,0.76-0.76h0 c0.42,0,0.76,0.34,0.76,0.76v2.9C15.11,26.04,14.77,26.38,14.35,26.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.08,26.38L8.08,26.38c-0.42,0-0.76-0.34-0.76-0.76v-2.9c0-0.42,0.34-0.76,0.76-0.76h0 c0.42,0,0.76,0.34,0.76,0.76v2.9C8.84,26.04,8.5,26.38,8.08,26.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.21,8.5c-1.5,0-2.72,1.22-2.72,2.72s1.22,2.72,2.72,2.72s2.72-1.22,2.72-2.72S12.71,8.5,11.21,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,20.34c-0.62-2.59-2.13-4.97-4.17-6.58c0.01-0.22,0.02-0.44,0.02-0.66c0-5.84-2.7-11.07-6.71-13.02 c-0.21-0.11-0.45-0.11-0.66,0C6.91,2,4.18,7.27,4.07,13.2c0,0.26,0,0.51,0.02,0.76c-2.04,1.74-3.48,4.02-4.07,6.48 c-0.06,0.23-0.01,0.48,0.14,0.66c0.15,0.18,0.37,0.28,0.59,0.28h2.41c1,0,1.93-0.45,2.53-1.25c0.05-0.06,0.08-0.13,0.12-0.2 c0.97,1,3.02,1.69,5.4,1.69c2.35,0,4.39-0.67,5.38-1.65c0.01,0.01,0.02,0.04,0.03,0.05c0.6,0.81,1.53,1.26,2.53,1.26h2.52 c0.22,0,0.44-0.1,0.59-0.29C22.41,20.81,22.46,20.56,22.4,20.34z M11.21,15.11c-2.15,0-3.9-1.74-3.9-3.89c0-2.15,1.75-3.9,3.9-3.9 s3.9,1.75,3.9,3.9C15.11,13.37,13.36,15.11,11.21,15.11z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsApadrinharIconFill);
export default __webpack_public_path__ + "static/media/icons_apadrinhar_icon_fill.5a25245a889a221191ce7d6349bfbd36.svg";
export { ForwardRef as ReactComponent };